import { Guid } from 'guid-typescript'
import _ from 'lodash'

export interface IActiveFilterModel {
  id: string
}

type ValueOrFactory<T> = T | (() => T)
type PartialValueOrFactory<T> = {
  [P in keyof T]?: ValueOrFactory<T[P]>
}

export class ActiveFilterModel implements IActiveFilterModel {
  private _value: ValueOrFactory<string>
  private _table: ValueOrFactory<string>
  private _column: ValueOrFactory<string>
  private _operator: ValueOrFactory<string>
  private _valueId: ValueOrFactory<number>
  private _type: ValueOrFactory<string>
  private _reportId: ValueOrFactory<number>

  get value(): string {
    return this.getValue(this._value)
  }

  get id(): string {
    return Guid.create().toString()
  }

  get table(): string {
    return this.getValue(this._table)
  }

  get column(): string {
    return this.getValue(this._column)
  }

  get operator(): string {
    return this.getValue(this._operator)
  }

  get valueId(): number {
    return this.getValue(this._valueId)
  }

  get type(): string {
    return this.getValue(this._type)
  }

  get reportId(): number {
    return this.getValue(this._reportId)
  }

  constructor(init?: PartialValueOrFactory<ActiveFilterModel>) {
    ;(Object as any).assign(
      this,
      _.mapKeys(init, (_value: any, key: string) => '_' + key)
    )
  }

  private getValue<T>(value: ValueOrFactory<T>): T {
    if (value instanceof Function) {
      return value()
    }

    return value
  }
}
